import {
  SUBMIT_GAS_INSTALLATION_DATA,
  SUBMIT_GAS_PERSON_DATA,
  SUBMIT_GAS_PAYMENT_DATA,
  SUBMIT_GAS_CONTRACT_DATA,
  SUBMIT_GAS_CONFIRMATION_DATA,
  NEW_GAS_CONTRACT_CONFIRM_REQUEST,
  NEW_GAS_CONTRACT_CONFIRM_RECEIVE,
  RECEIVE_GAS_CONTRACTATION_CONFIG,
  SET_GAS_LEAD_ID,
  SET_GAS_LEAD_STEP_CURRENT,
  SET_GAS_LEAD_INDEX_COMPLETED,
  SET_GAS_LEAD_ERRORS,
  SET_GAS_LEAD_SUBMIT_REQUEST,
  RESET_GAS_CONTRACTATION
} from "../../../constants";
import { createReducer } from "../../../utils/misc";
import gasContractationInitialState from "./gasContractationInitialState";

let reducerMap = {
  [SET_GAS_LEAD_ID]: (state, payload) => 
    Object.assign({}, state, {
      leadId: payload.leadId,
  }),
  [SET_GAS_LEAD_ID]: (state, payload) => ({
      ...state,
      gasLeadId: payload,
  }),
  [SET_GAS_LEAD_STEP_CURRENT]: (state, payload) =>
    Object.assign({}, state, {
      currentStep: {
        index: payload.index,
        name: payload.name
      }
  }),
  [SET_GAS_LEAD_INDEX_COMPLETED]: (state, payload) =>
    Object.assign({}, state, {
      completedSteps: {
        ...state.completedSteps,
        [payload.stepIndex]: true
      },
      latestStep: payload.stepIndex + 1,
      submitting: false
  }),
  [SET_GAS_LEAD_SUBMIT_REQUEST]: (state) =>
   Object.assign({}, state, {
    submitting: true,
  }),
  [SET_GAS_LEAD_ERRORS]: (state, payload) => {
    return {
      ...state,
      leadErrors: {
        ...state.leadErrors,
        ...payload
      }
    }
  },
  [SUBMIT_GAS_INSTALLATION_DATA]: (state, payload) => {
    const newState = {
      ...state,
      leadsConsent: payload.leadsConsent,
      steps: {
        ...state.steps,
        installation: {...payload}
      }
    };
    return newState;
  },
  [SUBMIT_GAS_PERSON_DATA]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        person: payload
      }
    }
  },
  [SUBMIT_GAS_CONTRACT_DATA]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        gasContract: payload
      }
    }
  },
  [SUBMIT_GAS_PAYMENT_DATA]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        payment: payload
      }
    }
  },
  [SUBMIT_GAS_CONFIRMATION_DATA]: (state, payload) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        confirmation: {
          ...state.steps.confirmation,
          ...payload
        }
      }
    }
  },
  [NEW_GAS_CONTRACT_CONFIRM_REQUEST]: (state) => {
    return {
      ...state,
      steps: {
        ...state.steps,
        confirmation: {
          ...state.steps.confirmation,
          isConfirming: true
        }
      }
    }
  },
  [NEW_GAS_CONTRACT_CONFIRM_RECEIVE]: (state, payload) =>{
    return {
      ...state,
      steps: {
        ...state.steps,
        confirmation: {
          ...state.steps.confirmation,
          ...payload,
          isConfirming: false
        }
      }
    }
  },
  // [FETCH_CONTRACTATION_CONFIG_REQUEST]: (state, payload) => {
  //   return {
  //     ...state,
  //     isFetching: true
  //   }
  // },
  [RECEIVE_GAS_CONTRACTATION_CONFIG]: (state, payload) => {
    return {
      ...state,
      config: {
        ...state.config,
        ...(payload ? payload : {}),
        isFetching: false
      }
    }
  },
  [RESET_GAS_CONTRACTATION]: (state) => {
      return initialState;
    }
};

export default createReducer(gasContractationInitialState, reducerMap);